<template>
	<div class="browserTips">
		<el-dialog :visible.sync="BrowserDialogShow" center width='350px'  class='browserDialog' :show-close='false' :lock-scroll='false'
		:close-on-press-escape='false' :close-on-click-modal='false' top='15vh'  destroy-on-close>
		<template #title>
			<div style="margin:0 20px">
				<div style="text-align: center">
					<el-image :src="require('@/assets/browser/ggxz@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 30px auto;'></el-image>
				</div>
				<div style='color: #000;text-align: center; '>当前浏览器不适配云游戏，请下载谷歌浏览器或更换谷歌内核版本更高的浏览器</div>
				<div style='font-size:12px;font-family:MicrosoftYaHei;color:rgba(109,114,120,1);text-align: center;' class="mini-tips">
					正在适配更多浏览器
				</div>
			</div>
		</template>
		<template #footer>
				<div >
					<el-button @click="closeDialog();" round style='background:rgba(248,248,248,1);' class='btnHover2'>
						我再看看
					</el-button>
					<el-button type="primary" @click="downloadChrome" round class='btnHover'
					style='background-color:rgba(249,221,74,1);color: #000;border-color: rgba(249,221,74,1);'>
						下载chrome
					</el-button>
				</div>
		</template>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		name:'browserTips',
		props:{
			BrowserDialogShow:Boolean,
		},
		data(){
			return{
				
			}
		},
		mounted() {
			let that = this;
			
		},
		methods:{
			downloadChrome(){
				let that = this;
				let url = 'https://www.google.cn/chrome/';
				window.open(url);
			},
			closeDialog(){
				let that = this;
				that.$bus.$emit('isIEShow',false);
			}
		},
		watch:{
			'browserDialogShow':function(val){
				let that = this;
				console.info(val)
			}
		}
	}
</script>

<style lang="less" scoped>
	.browserDialog{
		z-index: 2005;
		/deep/.el-dialog--center .el-dialog__body{
			padding: 10px 0;
		}
		.mini-tips{
			margin-top: 20px;
		}
	}
</style>
